// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
//
export function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
